// extracted by mini-css-extract-plugin
export default {"scormContent__iframeplayer":"ScormContent_scormContent__iframeplayer__ZpxcF","scormContent":"ScormContent_scormContent__u+4ki","hiddenIframe":"ScormContent_hiddenIframe__uATpi"};